var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionWikipediaDownloadColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H1V6H2.5L8 19H9L11.7083 13.5833L14 19H15L21.5 6H23V5H19V6H20L15 16L13 11L15.5 6H17V5H13V6H14L12.3333 9.33333L11 6H12V5H7V6H8.5L11.0208 11.9583L9 16L5 6H6V5Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18Z",
    fill: "#FFC30D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22L21 18L19 18V15L17 15L17 18H15L18 22Z",
    fill: "#5714CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionWikipediaDownloadColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_wikipedia_download_colored_day.7f8461228fc3bdc1ae49bbbdf32aaae5.svg";
export { ForwardRef as ReactComponent };